function InstaLogo(props) {
    return (
        <div>
            <a href='https://www.instagram.com/elementary_electric_co/'>
            <div style={{
                border: '2px solid #414243',
                width: '30px',
                height: '30px',
                borderRadius: '10px'
            }}>
                <div style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    border: '2px solid #414243',
                    marginLeft: '8px',
                    marginTop: '8px'
                }}>

                </div>

                <div style={{
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    backgroundColor: '#414243',
                    marginLeft: '22px',
                    marginTop: '-17.5px'
                }}>

                </div>

            </div>
            </a>
        </div>
    )
}

export default InstaLogo;